import React, { PureComponent } from 'react';
import PageContainer from '../../common/components/Page/PageContainer';
import AzureMap from './components/AzureMap/AzureMap';
import Tile from '../../common/components/Tile/Tile';
import InstrumentsList from './components/InstrumentsList/InstrumentsList';
import { Map as MapIcon } from '@mui/icons-material';
import './Dashboard.css';

class Dashboard extends PureComponent {
  render() {
    return (
      <PageContainer pageName="dashboard">
        {this.props.data.length ? (
          <AzureMap {...this.props} />
        ) : (
          <Tile
            className="u-mb-full"
            title="Instrument map"
            TitleIcon={MapIcon}
            helpTag="dashboard-map"
          >
            <div ref="map" className="map-container" data-qa="dashboard-map" />
          </Tile>
        )}
        <InstrumentsList {...this.props} />
      </PageContainer>
    );
  }
}

export default Dashboard;
